<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <ap-field
    [title]="'externalUser.email' | translate"
    [required]="true"
    [error]="emailField.touched && !!emailField.errors">
    <input appkit-field formControlName="email" />
    @if (emailField.touched && emailField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (emailField.touched && emailField.errors?.['email']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.email' | translate }}
      </div>
    }
  </ap-field>

  <ap-field
    [title]="'externalUser.firstName' | translate"
    [required]="true"
    [error]="firstNameField.touched && !!firstNameField.errors">
    <input
      appkit-field
      formControlName="firstName"
      [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - firstNameField.value.length }
      }}
    </div>
    @if (firstNameField.touched && firstNameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (firstNameField.touched && firstNameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{
          'form-validation-messages.alphabeticCharacters'
            | translate: { fieldName: 'First Name' }
        }}
      </div>
    }
  </ap-field>

  <ap-field
    [title]="'externalUser.lastName' | translate"
    [required]="true"
    [error]="lastNameField.touched && !!lastNameField.errors">
    <input
      appkit-field
      formControlName="lastName"
      [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - lastNameField.value.length }
      }}
    </div>
    @if (lastNameField.touched && lastNameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }

    @if (lastNameField.touched && lastNameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{
          'form-validation-messages.alphabeticCharacters'
            | translate: { fieldName: 'Last Name' }
        }}
      </div>
    }
  </ap-field>

  <ap-field
    [title]="'externalUser.organization' | translate"
    [required]="true"
    [error]="organizationField.touched && !!organizationField.errors">
    <input
      appkit-field
      formControlName="organization"
      [maxLength]="maxOrganizationLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate
            : {
                count: maxOrganizationLength - organizationField.value.length,
              }
      }}
    </div>
    @if (organizationField.touched && organizationField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
  </ap-field>

  <gstar-countries-combobox
    [required]="true"
    [value]="selectedCountry"
    (selectCountry)="countrySelect($event)"
    (clearCountry)="countryClear()" />

  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'client.isActive' | translate }}
  </ap-checkbox>
</form>
